import Link from 'next/link'
import React from 'react'

import UrbanBanner from '@/components/feature/UrbanBanner'
import InterviewPageContainer from '@/components/parts/interview/InterviewContainer'
import InterviewCustomerVoice from '@/components/parts/interview/InterviewCustomerVoice'
import InterviewMainImage from '@/components/parts/interview/InterviewMainImage'
import InterviewQA from '@/components/parts/interview/InterviewQA'
import {
  customerVoiceText,
  mainImageText,
  shizutesuQA,
} from '@/src/model/interview/shizutetsuModel'
import { urlPath } from '@/utils/lpPath'

const ShizutetsuInterview: React.FC = () => {
  return (
    <>
      <InterviewPageContainer
        company="しずてつソーサレア"
        interviewer="田村"
        ogUrl={`${process.env.NEXT_PUBLIC_PUBLIC_SITE_ORIGIN}${urlPath.shizutetsuSosarea}`}
        baseImageUrl="/images/interview/urbanGate"
      >
        <InterviewMainImage {...mainImageText} />
        <InterviewCustomerVoice {...customerVoiceText}>
          {React.Children.toArray(
            shizutesuQA.map(({ question, answer }, index) => (
              <InterviewQA
                key={'interview' + index}
                number={index}
                question={question}
                answer={answer}
                imgUrl={`/images/interview/shizutetsu/question${index + 1}.jpg`}
                isTextLeft={index % 2 == 1}
              />
            ))
          )}
          <div className="my-24 sp:mt-16 ">
            <h1 className="caption">お客様の声</h1>
            <div className="customer_voice_underline" />
            <UrbanBanner />
          </div>
          <div className="my-24 sp:mt-16">
            <Link href={urlPath.top} passHref>
              <a>
                <button className="return_button">戻る</button>
              </a>
            </Link>
            <a className="interviewTop" href={`#top`}>
              TOP
            </a>
          </div>
        </InterviewCustomerVoice>
      </InterviewPageContainer>
    </>
  )
}

export default ShizutetsuInterview
